<tt-card *ngIf="!!get && !!params">
    <tt-input ttRequired ttLabel="prosess_id" [(ttModel)]="get.prosess_id" ttMaxLength="30"></tt-input>
    <tt-input ttRequired ttLabel="prosess_name" [(ttModel)]="get.prosess_name" ttMaxLength="400"></tt-input>
    <tt-textarea ttLabel="description" [(ttModel)]="get.description"></tt-textarea>
    <tt-input-number ttLabel="complete_pst" [(ttModel)]="get.complete_pst" ttTextAlign="right"></tt-input-number>
    <tt-checkbox ttLabel="timeentry_allowed" [(ttModel)]="get.timeentry_allowed"></tt-checkbox>
    <tt-select ttLabel="pricemethod" [(ttModel)]="get.pricemethod_keyno" [ttData]="priceMethods"></tt-select>
    <tt-select ttLabel="tax" [(ttModel)]="get.tax_keyno" [ttData]="selectListTaxes"></tt-select>
    <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
    <tt-button *ngIf="params.projectprosess_keyno > '0'" ttText="projectprocess_delete" ttIcon="fas fa-trash" ttType="danger" (ttClick)="deleteProcess()" [ttLoading]="deleting"></tt-button>
</tt-card>
